import { render, staticRenderFns } from "./PromotionReportTable.vue?vue&type=template&id=16c3bacb"
import script from "./PromotionReportTable.vue?vue&type=script&lang=js"
export * from "./PromotionReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports